import { render, staticRenderFns } from "./EditPostponeDetail.vue?vue&type=template&id=543c36ec&scoped=true&"
import script from "./EditPostponeDetail.vue?vue&type=script&lang=js&"
export * from "./EditPostponeDetail.vue?vue&type=script&lang=js&"
import style0 from "./EditPostponeDetail.vue?vue&type=style&index=0&id=543c36ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c36ec",
  null
  
)

export default component.exports